import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderFr = () => {
    return (
        <HighlightedText
            text="RÉCLAMEZ VOTRE BONUS"
            highlights={[{ word: 'VOTRE' }, { word: 'BONUS' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentFr = () => {
    return (
        <HighlightedText
            text="bonus de 325% + 400 tours gratuits"
            highlights={[{ word: '325%' }, { word: '+' }, { word: '400' }]}
            breakAfterWords={['325%']}
            className={styles['text_content--FOURTH']}
        />
    )
}
